import { Calendar } from '@/components/Calendar'
import { Stack } from '@mui/material'
import { RecurrenceEndCalendarDropdown } from './RecurrenceCalendarDropdown/RecurrenceCalendarDropdown'
import { useCalendarProps } from './useCalendarProps'
// import { PopperMenu } from './PopperMenu'

type RecurrenceEndCalendarProps = {
  date: uui.domain.YYYYMMDD
}

export function RecurrenceEndCalendar(props: RecurrenceEndCalendarProps) {
  const { date } = props
  const calendarProps = useCalendarProps(date)

  return (
    <Stack
      sx={{ padding: 1, background: '#fff', gap: 2 }}
      data-testid="RecurrenceEndCalendar"
      data-trackid="RecurrenceEndCalendar"
    >
      <RecurrenceEndCalendarDropdown date={date} />
      <Calendar {...calendarProps} />
    </Stack>
    // <PopperMenu trigger={<RecurrenceEndCalendarDropdown date={date} />}>
    // </PopperMenu>
  )
}
